export default __webpack_public_path__ + "static/media/90min-com-logo-vector.52f439d3.svg";